// extracted by mini-css-extract-plugin
export var pageContainer = "_p-1";
export var settingsContent = "_p-0";